module.exports = __webpack_public_path__ + "static/media/australian-visa.4760d835.jpg";